// Selected equipments × passages per year × the line's duration. An estimate —
// date bounds are ignored — hence the ≈.

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['output', 'detail'];

  connect() {
    // The React combobox adds and removes hidden inputs without firing DOM events.
    this.observer = new MutationObserver(() => this.recompute())
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.recompute()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  recompute() {
    if (!this.hasOutputTarget) return

    const duration  = this.duration()
    const materials = this.materialsCount()
    const perYear   = this.occurrencesPerYear()
    const total     = duration * perYear * materials

    // The observer watches this subtree: an unconditional write would loop on itself.
    this.write(this.outputTarget, `≈ ${this.formatMinutes(total)}`)
    if (this.hasDetailTarget) {
      this.write(this.detailTarget, `${materials} × ${Math.round(perYear)} × ${this.formatMinutes(duration)}`)
    }
  }

  write(element, text) {
    if (element.textContent !== text) element.textContent = text
  }

  duration() {
    const hours   = parseInt(document.getElementById('predicted-duration-hours')?.value)   || 0
    const minutes = parseInt(document.getElementById('predicted-duration-minutes')?.value) || 0
    return hours * 60 + minutes
  }

  materialsCount() {
    const inputs = [...this.element.querySelectorAll('input[name="material_ids[]"]')]
      .filter(input => input.value !== '')
    return inputs.length || 1
  }

  occurrencesPerYear() {
    const interval  = parseInt(this.element.querySelector('select[name="maintenance_task[interval]"]')?.value) || 1
    const frequency = this.element.querySelector('select[name="maintenance_task[frequency]"]')?.value || 'MONTHLY'
    const days      = this.element.querySelectorAll('input[name="maintenance_task[days][]"]:checked').length
    const months    = this.element.querySelectorAll('input[name="maintenance_task[months][]"]:checked').length

    const monthShare = months > 0 ? months / 12 : 1

    switch (frequency) {
      case 'DAILY': {
        const dayShare = days > 0 ? days / 7 : 1
        return (365 / interval) * dayShare * monthShare
      }
      case 'WEEKLY':
        return (52 / interval) * (days || 1) * monthShare
      case 'MONTHLY':
        return months > 0 && interval === 1 ? months : (12 / interval) * monthShare
      case 'YEARLY':
        return 1 / interval
      default:
        return 0
    }
  }

  formatMinutes(total) {
    const rounded = Math.round(total)
    const hours   = Math.floor(rounded / 60)
    const minutes = rounded % 60
    if (hours === 0) return `${minutes}m`
    return minutes > 0 ? `${hours}h ${String(minutes).padStart(2, '0')}m` : `${hours}h`
  }
}
